<template>
    <div>
        <modal :show.sync="openFCI" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Fuente Captura de Información</h6>  
                <div class="row">
                    <div v-if="pymeMessage != null" class="alert alert-info">
                        <span>El valor actual del sistema es:<strong> {{ pymeMessage }}</strong></span>
                    </div>  
                    <p-button @click="saveCostsPymeData('Estados financieros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cubes mr-3"></i>
                        Estados financieros
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Software contable')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Software contable
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Registros en excel')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Registros en excel
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Libros contables')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Libros contables
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Otros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Otros
                    </p-button>
                </div>
                <template slot="footer">
                    <div class="left-side">
                        <p-button type="default" link @click="cancelOpenFCI()">Cancelar</p-button>
                    </div>
                    <div class="divider"></div>
                    <div class="right-side">
                        <p-button type="default" link @click="cancelOpenFCI()">Aceptar</p-button>
                    </div>
                </template>       
        </modal>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar producto</h6>
                <div v-if="monthlyNumber == ''" class="alert alert-danger mt-2">
                    <span>No ha ingresado cuántas veces compra insumos al mes</span>
                </div>
                <div class="form-group">
                    <label>Producto *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="producto"
                                placeholder="producto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('producto')"
                                v-model="productName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad *</label>
                    <fg-input   tabindex="1"
                                type="number"
                                name="cantidad"
                                placeholder="cantidad"
                                autocomplete="off"
                                v-validate="modelValidations.product_quantity"
                                :error="getError('cantidad')"
                                v-model="productQuantity">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Costo unidad</label>
                    <vue-numeric  :max=999999999999999 tabindex="2" currency="$" autocomplete="off" name="costo unidad" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="productCostUnity"></vue-numeric>
                </div>
                <div v-if="productCostTotalComputed != 0" class="alert alert-warning mt-2">
                    <span>Costo total: {{setFormat(productCostTotalComputed)}}</span>
                </div>
                <div v-if="productMonthlyCostComputed != 0" class="alert alert-warning mt-2">
                    <span>Costo mensual: {{setFormat(productMonthlyCostComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="monthlyNumber != ''" type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar producto</h6>
                <div v-if="monthlyNumber == ''" class="alert alert-danger mt-2">
                    <span>No ha ingresado cuántas veces compra insumos al mes</span>
                </div>
                <div class="form-group">
                    <label>Producto *</label>
                    <fg-input   tabindex="3"
                                type="text"
                                name="producto"
                                placeholder="producto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('producto')"
                                v-model="productName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad *</label>
                    <fg-input   tabindex="4"
                                type="number"
                                name="cantidad"
                                placeholder="cantidad"
                                autocomplete="off"
                                v-validate="modelValidations.product_quantity"
                                :error="getError('cantidad')"
                                v-model="productQuantity">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Costo unidad</label>
                    <vue-numeric  :max=999999999999999 tabindex="5" currency="$" autocomplete="off" name="costo unidad" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="productCostUnity"></vue-numeric>
                </div>
                <div v-if="productCostTotalComputed != 0" class="alert alert-warning mt-2">
                    <span>Costo total: {{setFormat(productCostTotalComputed)}}</span>
                </div>
                <div v-if="productMonthlyCostComputed != 0" class="alert alert-warning mt-2">
                    <span>Costo mensual: {{setFormat(productMonthlyCostComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="monthlyNumber != ''" type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Costeo general</h6>
                <p-button v-if="pyme" class="top-right-button" type="primary" @click="openFCIMethod()">FCI</p-button>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>¿Cuántas veces compra insumos al mes? *</label>
                    <fg-input   type="number"
                                name="cantidad"
                                placeholder="cantidad"
                                autocomplete="off"
                                v-validate="modelValidations.item_costs"
                                :error="getError('cantidad')"
                                v-model="monthlyNumber">
                    </fg-input>
                </div>
                <el-table v-if="products.length" :data="products"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Producto: {{ props.row.productName }}</p>
                            <p>Cantidad: {{ props.row.productQuantity }}</p>
                            <p>Precio: {{ setFormat(props.row.productCostUnity) }}</p>
                            <p>Precio total: {{ setFormat(props.row.productCostTotal) }}</p>
                            <p>Precio total mensual: {{ setFormat(props.row.productMonthlyCost) }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Producto" property="productName"></el-table-column>
                    <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.productMonthlyCost)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div>
                    <p-button 
                        @click="addProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar producto
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar producto
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar producto
                    </p-button>
                </div>
                <!-- <div v-if="allProductsMonthlyCostComputed != 0" class="alert alert-warning mt-2">
                    <span>Costo promedio mes: {{setFormat(allProductsMonthlyCostComputed)}}</span>
                </div> -->
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div v-if="allProductsMonthlyCostComputed != 0" class="alert alert-success">
            <span>Costos promedio mes: {{ setFormat(allProductsMonthlyCostComputed)}}</span>
        </div>
        <div v-if="this.$store.state.isCustomer && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales)}}</span>
        </div>
        <div v-if="this.$store.state.isSpouse && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales)}}</span>
        </div>
        <div v-if="this.$store.state.isGuarantor && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales)}}</span>
        </div>
        <div class="text-right">
            <p-button v-if="allProductsMonthlyCostComputed != 0" @click="saveCosts()" type="warning">Siguiente</p-button>
            <p-button @click="toItemGeneralSelection()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Table, TableColumn} from 'element-ui'
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            form: {
                average_selection: '',
            },
            pyme: false,
            openFCI: false,
            pymeMessage: null,
            currentRow: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            monthlyNumber: '',
            productName: '',
            productQuantity: '',
            productCostUnity: '',
            productCostTotal: '',
            productMonthlyCost: '',
            products: [
                
            ],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                sales: {
                    required: false
                },
                product_name: {
                    required: false,
                    max: 32
                },
                product_quantity: {
                    required: false,
                    max: 32,
                    numeric: true
                },
                item_costs: {
                    required: true,
                    min: 1,
                    max: 28
                },
                average_selection: {
                    required: false
                },
                item_name: {
                    required: false,
                    max: 32
                },
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            monthlyNumber: function(val) {
                for (let i=0;i<this.products.length;i++) {
                    var total = this.products[i].productQuantity * this.products[i].productCostUnity * val;
                    this.products[i].productMonthlyCost = total;
                }
            }
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productCostUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allProductsMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.products.length;i++) {
                    sum = sum + this.products[i].productMonthlyCost;
                }
                return sum
            },
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             setPymeCostsDescription (description) {
                this.pymeMessage = description;
                this.$store.commit('updateCustomerPECosts', description)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveCostsPymeData (description) {
                this.setPymeCostsDescription(description);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            openFCIMethod(){
                this.openFCI = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelOpenFCI(){ 
                this.openFCI = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             productValidator (product) {
                if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.pyme = true;
                }
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.itemName == '' || this.itemPercent == 0) {
                            this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                        }
                        else {
                            this.products[this.addProductIndex].items.push({
                                itemName: this.itemName,
                                itemPurchasePrice: this.itemPurchasePrice,
                                itemSalePrice: this.itemSalePrice,
                                itemPercent: this.itemPercent
                            })
                            this.resetItem();
                            this.addProduct = false;
                            this.addProductIndex = null;
                            this.showNotificationSuccess('Ítem agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.productName == '' || this.productMonthlyCost == 0) {
                            this.showNotificationError('El campo nombre de producto y total no pueden estar vacíos');
                        }
                        else {
                            var index = this.products.indexOf(this.currentRow);
                            this.products[index].productName = this.productName;
                            this.products[index].productQuantity = this.productQuantity;
                            this.products[index].productCostUnity = this.productCostUnity;
                            this.products[index].productCostTotal = this.productCostTotal;
                            this.products[index].productMonthlyCost = this.productMonthlyCost;
                            this.resetProduct();
                            this.currentRow = null;
                            this.$refs.productsTable.setCurrentRow();
                            this.editProduct = false;
                            this.showNotificationSuccess('Producto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod (row) {
                this.addProductIndex = row;
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.productName == '' || this.productMonthlyCost == 0) {
                            this.showNotificationError('El campo nombre de producto y total no pueden estar vacíos');
                        }
                        else {
                            this.products.push({
                                productName: this.productName,
                                productQuantity: this.productQuantity,
                                productCostUnity: this.productCostUnity,
                                productCostTotal: this.productCostTotal,
                                productMonthlyCost: this.productMonthlyCost,
                            })
                            this.resetProduct();
                            this.addProduct = false;
                            this.showNotificationSuccess('Producto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.productName = '',
                this.productQuantity = '',
                this.productCostUnity = '',
                this.productCostTotal = '',
                this.productMonthlyCost = ''
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.productName= this.currentRow.productName;
                this.productQuantity= this.currentRow.productQuantity;
                this.productCostUnity= this.currentRow.productCostUnity;
                this.productCostTotal= this.currentRow.productCostTotal;
                this.productMonthlyCost= this.currentRow.productMonthlyCost;
                this.editProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.resetProduct();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toItemGeneralSelection () {
                this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveCosts () {
                if (this.products.length == 0) {
                    this.showNotificationError('No hay productos');
                    return
                }
                if (this.allProductsMonthlyCostComputed != 0) {
                    this.$store.dispatch('setGeneralCosts', this.products).then(()=>{
                        this.$store.dispatch('setTotalCostsComputed', this.allProductsMonthlyCostComputed).then(()=>{
                            this.$store.dispatch('setMonthlyNumber', this.monthlyNumber).then(()=>{
                                this.$store.dispatch('setCostsDataPopulate', true).then(()=>{
                                    // if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salesPopulate == false) {
                                    //     this.$router.push('/asessments/new_asessment/customer/sales');
                                    // }
                                    // else {
                                    //     this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                                    // }
                                    if(this.pyme){
                                        var vm = this;
                                        swal({
                                            title: '¿Deseas agregar información de Salarios?',
                                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                            text: 'Si aceptas, podrás agregar o editar la información de los Salarios',
                                            type: 'info',
                                            showCancelButton: true,
                                            confirmButtonText: 'Si, aceptar',
                                            cancelButtonText: 'No, continuar',
                                            confirmButtonClass: 'btn btn-success btn-fill',
                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                            buttonsStyling: false
                                        }).then(() => {
                                            vm.$router.push('/asessments/new_asessment/customer/others/salary');
                                        }, function (dismiss) {
                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                            if (dismiss == 'cancel') {
                                                swal({
                                                    title: '¿Deseas agregar información de Obligaciones Financieras?',
                                                    text: 'Si aceptas, podrás agregar o editar la información de las Obligaciones Financieras',
                                                    type: 'info',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Si, aceptar',
                                                    cancelButtonText: 'No, continuar',
                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                    buttonsStyling: false
                                                }).then(() => {
                                                    vm.$router.push('/asessments/new_asessment/customer/others/financial-obligations');
                                                }, function (dismiss) {
                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                    if (dismiss == 'cancel') {
                                                        vm.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                                                    }
                                                    else {
                                                        swal({
                                                            title: 'Cancelado',
                                                            text: 'El analista no ha continuado',
                                                            type: 'error',
                                                            confirmButtonClass: 'btn btn-info btn-fill',
                                                            buttonsStyling: false
                                                        })
                                                    }
                                                })
                                                
                                            }
                                            else {
                                                swal({
                                                    title: 'Cancelado',
                                                    text: 'El analista no ha continuado',
                                                    type: 'error',
                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                    buttonsStyling: false
                                                })
                                            }
                                        })
                                    }
                                    else {
                                        this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                                    }
                                }); 
                            });                            
                        });
                    });
                    
                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                }
                
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductionItem.length != 0) {
                    var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: 'Ya existen datos para costeo por ítems, si continúa eliminará los datos anteriores',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            this.$store.dispatch('resetCosts').then(()=>{
                                this.showNotificationSuccess('Los costos han sido reiniciados');
                            });
                        }, function (dismiss) {
                            vm.$router.push('/asessments/new_asessment/customer/costs/production/item');
                        })
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate) {
                        this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].generalCosts;
                        this.monthlyNumber = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].monthlyNumber;
                    }
                }
            }
            else if(this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductionItem.length != 0) {
                    var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: 'Ya existen datos para costeo por ítems, si continúa eliminará los datos anteriores',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            this.$store.dispatch('resetCosts').then(()=>{
                                this.showNotificationSuccess('Los costos han sido reiniciados');
                            });
                        }, function (dismiss) {
                            vm.$router.push('/asessments/new_asessment/customer/costs/production/item');
                        })
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate) {
                        this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].generalCosts;
                        this.monthlyNumber = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].monthlyNumber;
                    }
                }
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductionItem.length != 0) {
                    var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: 'Ya existen datos para costeo por ítems, si continúa eliminará los datos anteriores',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            this.$store.dispatch('resetCosts').then(()=>{
                                this.showNotificationSuccess('Los costos han sido reiniciados');
                            });
                        }, function (dismiss) {
                            vm.$router.push('/asessments/new_asessment/customer/costs/production/item');
                        })
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate) {
                        this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].generalCosts;
                        this.monthlyNumber = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].monthlyNumber;
                    }
                }
            }
            if (this.$store.state.isCustomer) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].pe_costs || null;
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType)
                this.productValidator(product);   
            }
            else if(this.$store.state.isSpouse) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].pe_costs || null;
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType)
                this.productValidator(product);
            }
            else if(this.$store.state.isGuarantor) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].pe_costs || null;
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType)
                this.productValidator(product);
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    .top-right-button {
        position: absolute;
        top: 10px; /* Ajusta el espacio desde el borde superior */
        right: 10px; /* Ajusta el espacio desde el borde derecho */
    }
</style>
